import { NewLandingPage } from "@/components/landing/NewLandingPage";

const NewLanding = () => {
  return <NewLandingPage />;
};

export default NewLanding;